import { useEffect, useState } from "react"
import { Input, Button, Table, Space, Select, DatePicker, Modal, TreeSelect, message, Row, Col, Statistic } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import { CheckImgs } from "../../component/common/Imgs"
import moment from "moment"
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    visitStoreDate: any,
    visit_store_id: string[] | undefined,
    is_sample_food: number | undefined,
    is_make_deal: number | undefined,
    clueDate: any,
    customer_name: string | undefined,
    phone: string | undefined,
    contact_way: string | undefined,
    channel_id: string[] | undefined,
    channel_manager_id: string | undefined,
    customer_status: string | undefined,
    recordDate: any,
    first_belong_store_id: string[] | undefined,
    first_belong_sales_id: string | undefined,
    belong_store_id: string[] | undefined,
    init_sales_id: string | undefined,
    no_effective_reason_id: string | undefined,
    before_gone_init_store_id: string[] | undefined,
    before_gone_init_sales_id: string | undefined,
    before_gone_follow_sales_id: string | undefined,
    dealDate: any,
    deal_store_id: string[] | undefined,
    deal_sales_id: string | undefined,
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: boolean
}

type fromItem = {
    id: string,
    channel_name: string
}

type channelManager = {
    "id": string,
    "user_name": string
}

type followSales = {
    "id": string,
    "user_name": string
}

type loseType = {
    "id": string,
    "reason_desc": string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        visitStoreDate: null,
        visit_store_id: undefined,
        is_sample_food: undefined,
        is_make_deal: undefined,
        clueDate: null,
        customer_name: undefined,
        phone: undefined,
        contact_way: undefined,
        channel_id: undefined,
        channel_manager_id: undefined,
        customer_status: undefined,
        recordDate: null,
        first_belong_store_id: undefined,
        first_belong_sales_id: undefined,
        belong_store_id: undefined,
        init_sales_id: undefined,
        no_effective_reason_id: undefined,
        before_gone_init_store_id: undefined,
        before_gone_init_sales_id: undefined,
        before_gone_follow_sales_id: undefined,
        dealDate: null,
        deal_store_id: undefined,
        deal_sales_id: undefined,
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: true
    })

    const [initDate, setInitDate] = useState<boolean>(true)

    const [data, setData] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false)

    const [inChargeData, setInChargeData] = useState<channelManager[]>([])
    const [fromItemData, setFromItemData] = useState<fromItem[]>([])
    const [loseTypeData, setLoseTypeData] = useState<loseType[]>([])
    const [followSalesData, setFollowSalesData] = useState<followSales[]>([])

    const [urls, setUrls] = useState<string[]>([])
    const [swiperVisible, setSiperVisible] = useState<boolean>(false)

    const [inMoneyRecordVisible, setInMoneyRecordVisible] = useState<boolean>(false)
    const [inMoneyRecordData, setInMoneyRecordData] = useState<any>({ "total_agreement_amount": 0, "total_review_amount": 0, "total_pay_amount": 0, pay_records_list: [] })

    useEffect(() => {
        if (initDate) {
            var startDate = moment().startOf('month');
            var endDate = moment().endOf('month');
            // 初始化进店日期
            fetchOtherParams.visitStoreDate = [startDate, endDate];

            setInitDate(false)
        }

        fetch({ pagination, fetchOtherParams })
    }, [pagination.current, pagination.pageSize])

    useEffect(() => {
        // 查询来源渠道列表
        baseAxiosNoInfo('/finance_center/global/channel_source_list').then((res: any) => {
            res && setFromItemData(res)
        })

        baseAxiosNoInfo('/markting_center/global/no_effective_reason').then((res: any) => {
            res && setLoseTypeData(res)
        })

        baseAxiosNoInfo('/global/employee_list', { params: { position_number: 3 } }).then((res: any) => {
            res && setFollowSalesData(res)
        })

        baseAxiosNoInfo('/global/employee_list', { params: { position_number: 11 } }).then((res: any) => {
            res && setInChargeData(res)
        })
    }, [])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        p.pageSize = antPagination.pageSize

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'clueDate', ['start_clue_date', 'end_clue_date'])
        handleDate(params, 'recordDate', ['start_create_time', 'end_create_time'])
        handleDate(params, 'visitStoreDate', ['start_visit_store_date', 'end_visit_store_date'])
        handleDate(params, 'dealDate', ['start_deal_date', 'end_deal_date'])

        if (params.channel_id) {
            params.channel_id = params.channel_id.join(',')
        }

        if (params.first_belong_store_id) {
            params.first_belong_store_id = params.first_belong_store_id.join(',')
        }

        if (params.belong_store_id) {
            params.belong_store_id = params.belong_store_id.join(',')
        }

        if (params.before_gone_init_store_id) {
            params.before_gone_init_store_id = params.before_gone_init_store_id.join(',')
        }

        if (params.visit_store_id) {
            params.visit_store_id = params.visit_store_id.join(',')
        }

        if (params.deal_store_id) {
            params.deal_store_id = params.deal_store_id.join(',')
        }

        axiosTable.get('/markting_center/customer/visit/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setInitDate(false)
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const exportExcel = () => {
        message.success('此次导出需要较长时间，请稍等..')

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total
        delete iPagination.showSizeChanger

        let params: any = { ...fetchOtherParams }

        handleDate(params, 'clueDate', ['start_clue_date', 'end_clue_date'])
        handleDate(params, 'recordDate', ['start_create_time', 'end_create_time'])
        handleDate(params, 'visitStoreDate', ['start_visit_store_date', 'end_visit_store_date'])
        handleDate(params, 'dealDate', ['start_deal_date', 'end_deal_date'])

        if (params.channel_id) {
            params.channel_id = params.channel_id.join(',')
        }

        if (params.first_belong_store_id) {
            params.first_belong_store_id = params.first_belong_store_id.join(',')
        }

        if (params.belong_store_id) {
            params.belong_store_id = params.belong_store_id.join(',')
        }

        if (params.before_gone_init_store_id) {
            params.before_gone_init_store_id = params.before_gone_init_store_id.join(',')
        }

        if (params.visit_store_id) {
            params.visit_store_id = params.visit_store_id.join(',')
        }

        if (params.deal_store_id) {
            params.deal_store_id = params.deal_store_id.join(',')
        }

        baseAxiosComplete('/markting_center/customer/visit/excel', {
            params: {
                ...iPagination,
                ...params
            }

        }).then(res => {
            if (res.status === 0) {
                window.open(res.data)
            }
        })
    }

    const recursionChildren = (children: any[]) => {
        let childArr: any = []

        children.forEach((el: any) => {
            childArr.push({
                title: el.channel_name,
                value: el.id,
                key: el.id,
                children: el.children && recursionChildren(el.children)
            })
        })

        return childArr
    }

    function handleDate(param: any, attr: string, realDateParams: string[]): void {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    let inChargeOptions = inChargeData.map((el: any) => (<Option value={el.id} key={el.id}>{el.user_name}</Option>))
    let followSalesOptions = followSalesData.map((el: any) => (<Option value={el.id} key={el.id}>{el.user_name}</Option>))

    return (<div className="common-page">
        {/* 营销中心 -> 客资管理 -> 进店客资池 */}
        <BreadCrumb position={['营销中心', '进店客资池']} />

        <div className="common-top-form">
            <Row gutter={16} style={{ marginBottom: 20, marginLeft: 20 }}>
                <Col span={6}>
                    <Statistic title="我的总客资" value={pagination.total} />
                </Col>
            </Row>

            <Space direction="horizontal" wrap>
                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["进店开始日期", "进店结束日期"]} value={fetchOtherParams.visitStoreDate} onChange={(v: any) => { handleChange(v, 'visitStoreDate') }} />
                <div style={{ marginRight: 8, marginBottom: 12 }} className="fl" >
                    <SelectStores
                        multiple
                        showSearch
                        placeholder="参观门店"
                        value={fetchOtherParams.visit_store_id}
                        onChange={(v: string[]) => { handleChange(v, 'visit_store_id') }}
                    />
                </div>
                <Select allowClear className="fl" style={{ marginRight: 8, marginBottom: 12, width: 150 }} placeholder="是否试吃月子餐" value={fetchOtherParams.is_sample_food} onChange={(v: number) => { handleChange(v, 'is_sample_food') }}>
                    <Option value={0} key={0}>否</Option>
                    <Option value={1} key={1}>是</Option>
                </Select>
                <Select allowClear className="fl" style={{ marginRight: 8, marginBottom: 12, width: 150 }} placeholder="是否签单" value={fetchOtherParams.is_make_deal} onChange={(v: number) => { handleChange(v, 'is_make_deal') }}>
                    <Option value={0} key={0}>否</Option>
                    <Option value={1} key={1}>是</Option>
                </Select>

                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["线索开始日期", "线索结束日期"]} value={fetchOtherParams.clueDate} onChange={(v: any) => { handleChange(v, 'clueDate') }} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="客户姓名" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'customer_name') }} value={fetchOtherParams.customer_name} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="手机号" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'phone') }} value={fetchOtherParams.phone} />
                <Input className="fl" style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="其他联系方式" onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'contact_way') }} value={fetchOtherParams.contact_way} />
                <Select
                    allowClear
                    showSearch
                    mode="multiple"
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 250 }}
                    placeholder="客资状态（多选）"
                    value={fetchOtherParams.customer_status === undefined ? undefined : fetchOtherParams.customer_status.split(',')}
                    onChange={(v: any[]) => {
                        handleChange(v.length > 0 ? v.join(',') : undefined, 'customer_status')
                    }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    <Option value={'3'} key={3}>待跟进</Option>
                    <Option value={'4'} key={4}>待预约进店</Option>
                    <Option value={'5'} key={5}>已预约待进店</Option>
                    <Option value={'6'} key={6}>已进店</Option>
                    <Option value={'7'} key={7}>已签单</Option>
                    <Option value={'8'} key={8}>待激活</Option>
                    <Option value={'9'} key={9}>已流失</Option>
                </Select>

                <TreeSelect
                    showSearch
                    multiple={true}
                    allowClear
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 230 }}
                    value={fetchOtherParams.channel_id}
                    virtual={false}
                    treeData={recursionChildren(fromItemData)}
                    placeholder="来源渠道（可多选）"
                    onChange={(v: any) => {
                        handleChange(v, 'channel_id')
                    }}
                    filterTreeNode={(inputValue: any, treeNode: any) => (treeNode.title.indexOf(inputValue) != -1)}
                />
                <Select
                    allowClear
                    showSearch
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 150 }}
                    placeholder="来源渠道负责人"
                    value={fetchOtherParams.channel_manager_id}
                    onChange={(v: string) => { handleChange(v, 'channel_manager_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {inChargeOptions}
                </Select>

                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 250 }} className="fl" placeholder={["录入开始日期", "录入结束日期"]} value={fetchOtherParams.recordDate} onChange={(v: any) => { handleChange(v, 'recordDate') }} />
                <div style={{ marginRight: 8, marginBottom: 12 }} className="fl" >
                    <SelectStores
                        multiple
                        showSearch
                        placeholder="首次分配门店"
                        value={fetchOtherParams.first_belong_store_id}
                        onChange={(v: string[]) => { handleChange(v, 'first_belong_store_id') }}
                    />
                </div>
                <Select
                    allowClear
                    showSearch
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 130 }}
                    placeholder="首次分配销售"
                    value={fetchOtherParams.first_belong_sales_id}
                    onChange={(v: string) => { handleChange(v, 'first_belong_sales_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {followSalesOptions}
                </Select>
                <div style={{ marginRight: 8, marginBottom: 12 }} className="fl" >
                    <SelectStores
                        multiple
                        showSearch
                        placeholder="当前所属门店"
                        value={fetchOtherParams.belong_store_id}
                        onChange={(v: string[]) => { handleChange(v, 'belong_store_id') }}
                    />
                </div>
                <Select
                    showSearch
                    allowClear
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 120 }}
                    placeholder="所属销售"
                    value={fetchOtherParams.init_sales_id}
                    onChange={(v: string) => { handleChange(v, 'init_sales_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {followSalesOptions}
                </Select>

                <Select
                    showSearch
                    mode="multiple"
                    virtual={false}
                    allowClear
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 250 }}
                    placeholder="最新流失分类(可多选)"
                    value={fetchOtherParams.no_effective_reason_id === undefined ? undefined : fetchOtherParams.no_effective_reason_id.split(',')}
                    onChange={(v: any) => {
                        handleChange(v.length > 0 ? v.join(',') : undefined, 'no_effective_reason_id')
                    }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {loseTypeData.map((el: loseType) => <Option value={el.id} key={el.id}>{el.reason_desc}</Option>)}
                </Select>
                <div style={{ marginRight: 8, marginBottom: 12 }} className="fl" >
                    <SelectStores
                        showSearch
                        multiple
                        placeholder="流失前初始门店"
                        value={fetchOtherParams.before_gone_init_store_id}
                        onChange={(v: string[]) => { handleChange(v, 'before_gone_init_store_id') }}
                    />
                </div>
                <Select
                    showSearch
                    allowClear
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 150 }}
                    placeholder="流失前初始销售"
                    value={fetchOtherParams.before_gone_init_sales_id}
                    onChange={(v: string) => { handleChange(v, 'before_gone_init_sales_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {followSalesOptions}
                </Select>
                <Select
                    showSearch
                    allowClear
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 150 }}
                    placeholder="流失前跟进销售"
                    value={fetchOtherParams.before_gone_follow_sales_id}
                    onChange={(v: string) => { handleChange(v, 'before_gone_follow_sales_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {followSalesOptions}
                </Select>

                <RangePicker style={{ marginRight: 8, marginBottom: 12, width: 300 }} className="fl" placeholder={["签单开始日期", "签单结束日期"]} value={fetchOtherParams.dealDate} onChange={(v: any) => { handleChange(v, 'dealDate') }} />
                <div style={{ marginRight: 8, marginBottom: 12 }} className="fl" >
                    <SelectStores
                        multiple
                        showSearch
                        placeholder="签单门店"
                        value={fetchOtherParams.deal_store_id}
                        onChange={(v: string[]) => { handleChange(v, 'deal_store_id') }}
                    />
                </div>
                <Select
                    showSearch
                    allowClear
                    className="fl"
                    virtual={false}
                    style={{ marginRight: 8, marginBottom: 12, width: 120 }}
                    placeholder="签单销售"
                    value={fetchOtherParams.deal_sales_id}
                    onChange={(v: string) => { handleChange(v, 'deal_sales_id') }}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {followSalesOptions}
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn fl" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { exportExcel() }} type="dashed" >导出</Button>
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column title="参观日期" dataIndex="visit_store_date" key="visit_store_date" />
                <Column title="参观门店" dataIndex="visit_store_name" key="visit_store_name" />
                <Column title="是否试吃月子餐" dataIndex="sample_food" key="sample_food" />
                <Column title="是否签单" dataIndex="make_deal" key="make_deal" />

                <Column title="客户姓名" dataIndex="user_name" key="user_name" />
                <Column title="手机号" dataIndex="phone" key="phone" />
                <Column title="其他联系方式" dataIndex="contact_way" key="contact_way" />

                <Column title="怀孕状态" dataIndex="preg_status" key="preg_status" render={(v: number) => {
                    switch (v) {
                        case 1:
                            return '正在备孕'
                        case 2:
                            return '已经怀孕'
                        case 3:
                            return '已有宝宝'
                        case 4:
                            return '小月子'
                        case 0:
                            return '未知'
                        default:
                            return ''
                    }
                }} />
                <Column title="预产期" dataIndex="expect_born_day" key="expect_born_day" />

                <Column width="200px" title="客资状态" dataIndex="status" key="status" render={(v: number) => {
                    switch (v) {
                        case 3:
                            return '待跟进'
                        case 4:
                            return '待预约进店'
                        case 5:
                            return '已预约待进店'
                        case 6:
                            return '已进店'
                        case 7:
                            return '已签单'
                        case 8:
                            return '待激活'
                        case 9:
                            return '已流失'
                        default:
                            return ''
                    }
                }} />

                <Column title="来源渠道" dataIndex="channel_name" key="channel_name" />
                <Column title="所在城市" dataIndex="location_city_name" key="location_city_name" />
                <Column title="意向门店" dataIndex="intention_store_name" key="intention_store_name" />

                <Column title="录入人/角色" render={(v: any) => {
                    return <p>{v.create_user_name}/{v.create_user_position}</p>
                }} />
                <Column title="录入时间" dataIndex="create_time" key="create_time" />
                <Column title="报备内容" dataIndex="remark" key="remark" width={650} render={
                    info => {
                        let br = <br></br>;
                        let result = null;
                        let content_list = info.split('\n')

                        for (let j = 0; j < content_list.length; j++) {
                            if (j === 0) {
                                result = content_list[j];
                            } else {
                                result = <span>{result}{br}{content_list[j]}</span>;
                            }
                        }

                        return <div>{result}</div>;
                    }}
                />

                <Column title="首次分配门店" dataIndex="first_belong_store_name" key="first_belong_store_name" />
                <Column title="首次分配销售" dataIndex="first_belong_sales_name" key="first_belong_sales_name" />
                <Column title="当前所属门店" width="120px" dataIndex="belong_store_name" key="belong_store_name" />
                <Column title="所属销售" width="120px" dataIndex="init_sales_name" key="init_sales_name" />
                <Column title="跟进销售" dataIndex="follow_sales_name" key="follow_sales_name" />

                <Column title="最新流失分类" dataIndex="no_effective_reason" key="no_effective_reason" />
                <Column title="流失前初始门店" dataIndex="before_gone_init_store_name" key="before_gone_init_store_name" />
                <Column title="流失前初始销售" dataIndex="before_gone_init_sales_name" key="before_gone_init_sales_name" />
                <Column title="流失前跟进销售" dataIndex="before_gone_follow_sales_name" key="before_gone_follow_sales_name" />

                <Column title="最新跟进等级" dataIndex="last_follow_level" key="last_follow_level" />

                <Column title="签单录入时间" dataIndex="deal_create_time" key="deal_create_time" />
                <Column title="签单日期" dataIndex="deal_date" key="deal_date" />
                <Column title="签单门店" dataIndex="deal_store_name" key="deal_store_name" />
                <Column title="签单销售" dataIndex="deal_sales_name" key="deal_sales_name" />
                <Column title="签单套餐" dataIndex="deal_item_name" key="deal_item_name" />

                <Column title="套餐天数/赠送天数" render={(v: any) => {
                    if (v.item_days || v.gift_days) {
                        return <span>{v.item_days}/{v.gift_days}</span>
                    } else {
                        return null
                    }
                }} />
                <Column title="合同凭证" render={(row: any) => {
                    if (row.status === 7) {
                        return <Button onClick={() => {
                            setUrls(row.deal_prov_pic_list)
                            setSiperVisible(true)
                        }} size="small" >查看</Button>

                    } else {
                        return null
                    }
                }} />

                <Column title="合同金额" dataIndex="agreement_amount" key="agreement_amount" />
                <Column title="已收总金额" render={(v: any) => {
                    return (<Button onClick={() => {
                        setInMoneyRecordVisible(true)
                        baseAxiosNoInfo('/markting_center/customer/intention/pay_records_list', { params: { id: v.id } }).then((res: any) => {
                            res ? setInMoneyRecordData(res) : setInMoneyRecordData({ "total_agreement_amount": 0, "total_review_amount": 0, "total_pay_amount": 0, pay_records_list: [] })
                        })
                    }} type="dashed" size="small">{v.total_pay_amount}</Button>)
                }}
                />
            </Table>
        </div>

        {/* 弹窗：合同凭证 */}
        <CheckImgs tinyURL={urls} visible={swiperVisible} onCancel={() => { setSiperVisible(false) }} />

        {/* 弹窗：已收金额记录 */}
        <Modal zIndex={10} width={1000} bodyStyle={{ minHeight: 600 }} title="已收金额记录" visible={inMoneyRecordVisible} onCancel={() => { setInMoneyRecordVisible(false) }} footer={false}>
            <p style={{ fontSize: '18px', color: '#faad14' }}>合同总金额：{inMoneyRecordData.total_agreement_amount}元</p>
            <p>已收总金额：{inMoneyRecordData.total_pay_amount}元，已审核金额：{inMoneyRecordData.total_review_amount}元</p>

            <Table scroll={{ x: 'max-content' }} pagination={false} dataSource={inMoneyRecordData.pay_records_list}>
                <Column title="客户姓名" dataIndex="user_name" key="user_name" />
                <Column title="收款日期" dataIndex="pay_date" key="pay_date" />
                <Column title="收款项目" dataIndex="pay_item" key="pay_item" />
                <Column title="收款单号" dataIndex="pay_code" key="pay_code" />
                <Column title="收款方式" dataIndex="pay_way" key="pay_way" render={(v: number) => {
                    if (v === 1) {
                        return '现金'
                    } else if (v === 2) {
                        return '支付宝'
                    } else if (v === 3) {
                        return '微信'
                    } else if (v === 4) {
                        return '银联卡'
                    } else {
                        return ''
                    }
                }} />
                <Column title="收款金额" dataIndex="pay_amount" key="pay_amount" />
                <Column width="120px" title="收款凭证" render={(row: any) => {
                    return <Button onClick={() => {
                        setUrls(row.pay_prov_pic_list)
                        setSiperVisible(true)
                    }} size="small" >查看</Button>
                }} />
                <Column title="收款人" dataIndex="deal_sales_name" key="deal_sales_name" />

                <Column title="审核状态" dataIndex="review_status" key="review_status" render={(v: number) => {
                    if (v === 0) {
                        return '待审核'
                    } else if (v === 1) {
                        return '审核通过'
                    } else if (v === 2) {
                        return '审核不通过'
                    } else {
                        return ''
                    }
                }} />
                <Column title="审核拒绝原因" dataIndex="review_refuse_reason" key="review_refuse_reason" />
                <Column title="审核人" dataIndex="review_user_name" key="review_user_name" />
                <Column title="审核时间" dataIndex="review_time" key="review_time" />
            </Table>
        </Modal>
    </div>)
}